import Swiper from 'swiper';
import ww from '../globals.js';

$(document).ready(() => {

  // on the main page

  if ($('.slider-init').length && ww < 576) {
	  $('.swiper-slide')
	  	.addClass('mob-slides');
    new Swiper('.slider-init', {
      centeredSlides: true,
      slidesPerView: 1.2,
      spaceBetween: 15,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
    });
  };

  // on the product page gallery thumbs

  const productThumbs =  new Swiper('.product-gallery__thumbs', {
    slidesPerView: 4,
    spaceBetween: 16,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 16
      },
      500: {
        slidesPerView: 4,
        spaceBetween: 5
      },
      380: {
        slidesPerView: 3,
        spaceBetween: 0
      },
      310: {
        slidesPerView: 2,
        spaceBetween: 0
      },
    }
  });

  // on the product page gallery

  new Swiper('.product-slider__gallery', {
    spaceBetween: 10,
    slidesPerView: 1,

    thumbs: {
      swiper: productThumbs,
    }
  });

}); 
